<template>
  <div class="data-grid">
    <div>
      <label>CUIT</label>
      <span>{{ organization.cuit }}</span>
    </div>
    <div>
      <label>Razón social</label>
      <span>{{ organization.businessName }}</span>
    </div>
    <div>
      <label>Situación frente al impuesto a la ganancia</label>
      <span>{{ organization.incomeTaxSituation }}</span>
    </div>
    <div>
      <label>Situación frente al IVA</label>
      <span>{{ organization.ivaSituation }}</span>
    </div>
    <div>
      <label>Teléfono Institucional</label>
      <span>{{ organization.phone }}</span>
    </div>
    <div>
      <label>Correo electrónico institucional</label>
      <span>{{ organization.email }}</span>
    </div>
    <div>
      <label>País</label>
      <span>{{ organization.country }}</span>
    </div>
    <div>
      <label>Provincia</label>
      <span>{{ organization.state }}</span>
    </div>
    <div>
      <label>Localidad</label>
      <span>{{ organization.city }}</span>
    </div>
    <div>
      <label>Código Postal</label>
      <span>{{ organization.zipcode }}</span>
    </div>
    <div>
      <label>Direción comercial</label>
      <span>{{ organization.commercialAddress }}</span>
    </div>
    <div v-if="organization.productionMothers">
      <label>Cantidad de Madres de Producción</label>
      <span>{{ organization.productionMothers }}</span>
    </div>
    <div v-if="organization.slaughterQuantityPerMonth">
      <label>Cantidad de animales enviados a faena por mes</label>
      <span>{{ organization.slaughterQuantityPerMonth }}</span>
    </div>
    <div v-if="organization.ruca">
      <label>Matrícula RUCA</label>
      <span>{{ organization.ruca }}</span>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import axios from 'axios'
import { print } from 'graphql'
import Vue from 'vue'

axios.defaults.headers.common['referer-id'] = new Date().toLocaleString().replace(/[^\d]/g, '') + parseInt(Math.random() * 100000)

export default {
  name: 'entity-data',
  data() {
    return {
      totalPages: '',
    }
  },
  props: {
    organization: {
      type: Object,
      required: true
    }
  }
}
</script>
